const getPropsToDisplayModifiers = propsToDisplay =>
  propsToDisplay.map(({ modifier }) => modifier || '');

export default getPropsToDisplayModifiers;
